import httpClient from './httpClient'

export default {
  Case: {
    CreateArtifact(payload) {
      return httpClient.post('/Case/CreateArtifact', payload)
    },
    GetCases(payload) {
      return httpClient.post('/Case/GetCases', payload)
    },
    GetCase(payload) {
      return httpClient.post('/Case/GetCase', payload)
    },
    GetRecentActivity(payload) {
      return httpClient.post('/Case/GetRecentActivity', payload)
    },
    GetRecentCases(payload) {
      return httpClient.post('/Case/GetRecentCases', payload)
    },
    CreateCase(payload) {
      return httpClient.post('/Case/CreateCase', payload)
    },
    GetCaseIncidentTypes() {
      return httpClient.post('/Case/GetCaseIncidentTypes')
    },
    GetCountsByLocation(payload) {
      return httpClient.post('/Case/GetCountsByLocation', payload)
    },
    AddClip(payload) {
      return httpClient.post('/Case/AddClip', payload)
    },
    Update(payload) {
      return httpClient.post('Case/Update', payload)
    },
    RetryArtifact(payload) {
      return httpClient.post('Case/RetryArtifact', payload)
    },
    DeleteCase(payload) {
      return httpClient.post('Case/Delete', payload)
    },
    CreateOrUpdateCaseShare(payload) {
      return httpClient.post(
        'ExternalUserCase/CreateOrUpdateCaseShare',
        payload
      )
    },
    CreateOrUpdateCaseGroupShare(payload) {
      return httpClient.post(
        'ExternalUserCase/CreateOrUpdateCaseGroupShare',
        payload
      )
    },
    GetExternalUserByCase(payload) {
      return httpClient.post('ExternalUserCase/GetExternalUserByCase', payload)
    },
    GetExternalUserByCaseGroup(payload) {
      return httpClient.post(
        'ExternalUserCase/GetExternalUserByCaseGroup',
        payload
      )
    },
    DeleteCaseShare(payload) {
      return httpClient.post('ExternalUserCase/DeleteCaseShare', payload)
    },
    CreateCaseGroup(payload) {
      return httpClient.post('Case/CreateCaseGroup', payload)
    },
    GetCaseGroup(payload) {
      return httpClient.post('Case/GetCaseGroup', payload)
    },
    UpdateCaseGroup(payload) {
      return httpClient.post('Case/UpdateCaseGroup', payload)
    },
    DeleteCaseGroup(payload) {
      return httpClient.post('Case/DeleteCaseGroup', payload)
    },
    DeleteCaseFromCaseGroup(payload) {
      return httpClient.post('Case/DeleteCaseFromCaseGroup', payload)
    },
    GetCaseAudits(payload) {
      return httpClient.post('Case/GetCaseAudits', payload)
    },
    GetCaseAuditsReport(payload) {
      return httpClient.post(
        'Case/GetCaseAuditsReport',
        payload,
        payload.config
      )
    },
  },
}
